<template>
  <div id="modifiers">
    <ModifierNavigation/>
    <br/>
    <Datatable
      v-if="inventory"
      entity="modifier"
      class="datatable"
      ref="datatable"
      :parameters="{inventory: inventory.id}"
      :onRowClick="onRowClick"
      :globalActions="[
        {text: 'modifiers.new', method: onCreate, condition: function() { return $store.getters.loggedUserCanModifyInventory }},
        {text: 'display_priority', method: goToDisplayPriority, condition: function() { return $store.getters.loggedUserCanModifyInventory }}]"
      :rowActions="[
        {text: 'datatable.edit', method: onRowEdit},
        {text: 'datatable.delete', method: onRowDelete, condition: function() { return $store.getters.loggedUserCanModifyInventory }}
      ]">
    </Datatable>
  </div>
</template>

<script>

  import ModifierNavigation from '@/components/modifiers/Navigation.vue'
  import Datatable from '@/components/Datatable.vue'
  import { mapActions } from "vuex";

  export default {

    name: "modifiers",

    components: { ModifierNavigation, Datatable },

    data() {
      return {
        entityName: 'modifiers'
      }
    },

    computed: {
      inventory() {
        return this.$store.state.contextInventory
      }
    },

    async mounted() {
      this.$store.state.pageTitleTranslationKey = "inventory.modifiers";
      this.$store.state.pageIcon = "/icon/menu.svg";
    },

    methods: {

      ...mapActions(["deleteInventoryEntity"]),

      edit(id) {
        this.$router.push({ path: '/modifiers/edit', query : Object.assign({id : id, inventory: this.inventory.id}, this.$route.query) });
      },
      onCreate() {
        this.edit(null)
      },
      onRowClick(row) {
        this.edit(row.id);
      },
      onRowEdit(row) {
        this.edit(row.id)
      },
      goToDisplayPriority() {
        this.$router.push({ path: '/modifiers/priority', query : Object.assign({inventory: this.inventory.id}, this.$route.query) });
      },
      async onRowDelete(row) {
        await this.deleteInventoryEntity({ entity: this.entityName, inventory: this.inventory.id, id: row.id });
        this.$refs.datatable.query();
      }
    }
  }

</script>

<style lang="scss" scoped>

</style>
